"use client";

import type { SupTransactionType } from "@/types";
import React, { useMemo } from "react";

import { SupShoppingBag } from "@repo/core-ui";
import { SupButton, SupText } from "@repo/core-ui";
import { useStoredData, useStoredDataDispatch } from "@/store/Context";
import { classNames, notifyMessage } from "@/utils";

interface Web3CommonCartClearProps {
  type?: SupTransactionType;
  handleClose?: any;
}

export default function Web3CommonCartClear({ handleClose, type = "deposit" }: Web3CommonCartClearProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();
  const handleClear = () => {
    handleClose?.();
    notifyMessage(`${type === "deposit" ? "Deposit" : "Withdraw"} bag cleared`, "All vaults removed from the bag", "info", <SupShoppingBag />);
    storedDispatch({ type: type === "deposit" ? "clearCart" : "clearWithdrawCart" });
    storedDispatch({ type: "closeOverlay" });
  };

  const disabled = useMemo(() => {
    return type === "deposit" ? !storedData.cart.length : !storedData.withdrawCart.length;
  }, [storedData.cart, storedData.withdrawCart, type]);

  return (
    <SupButton variant="text" className="h-fit" disabled={disabled} onClick={handleClear}>
      <span className="sr-only">Remove all vaults</span>
      <SupText variant="subtitle2" weight="regular" family="mono" className={classNames(disabled ? "text-neutral-300" : "text-neutral-900")}>
        Clear all
      </SupText>
    </SupButton>
  );
}
